import { HeaderTitle } from "@/components/header/title";
import { CloseIcon } from "@/components/icons/close-icon";
import IconButton from "@/components/ui/buttons/IconButton";
import { cn } from "@/utils/cn";
import { memo } from "react";

interface PlanDetailBottomSheetHeaderProps {
  /**
   * Modal title to display
   */
  title: string;
  /**
   * Callback when close button is clicked
   */
  onDismiss: () => void;
}

/**
 * Shared header component for plan detail bottom sheet modals
 * Used in Ingredients and Method modals
 */
export const PlanDetailBottomSheetHeader = memo(function PlanDetailBottomSheetHeader({
  title,
  onDismiss,
}: PlanDetailBottomSheetHeaderProps) {
  return (
    <div className={cn("sticky top-0 z-10 px-3 py-0 pt-[var(--safe-area-inset-top)]")}>
      <div className="flex h-[68px] items-center justify-center gap-3">
        <IconButton onClick={onDismiss} className="bg-button-close-modal-default">
          <CloseIcon className="h-6 w-6 text-black" />
        </IconButton>
        <div className="flex flex-1 flex-col items-center justify-center gap-2">
          <HeaderTitle title={title} className="text-white" />
        </div>
        <div className="w-11" />
      </div>
    </div>
  );
});
